'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RSAPublicKey = exports.RSAPrivateKey = undefined;

var _nodeForge = require('node-forge');

var _aes = require('../aes');

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ============================================================================
// ====                           PRIVATE KEY                              ====
// ============================================================================

var RSAPrivateKey = exports.RSAPrivateKey = function RSAPrivateKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var generate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  _classCallCheck(this, RSAPrivateKey);

  _initialiseProps.call(this);

  if (key) this._key = key;else if (generate) this.generate();
};

// ============================================================================
// ====                           PUBLIC KEY                               ====
// ============================================================================

RSAPrivateKey.generateAsync = function () {
  return new Promise(function (resolve, reject) {
    _nodeForge.rsa.generateKeyPair({ bits: 2048, workers: -1 }, function (err, _ref) {
      var privateKey = _ref.privateKey;

      if (err) return reject(err);
      var key = new RSAPrivateKey(null, false);
      key._key = privateKey;
      return resolve(key);
    });
  });
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.generate = function () {
    _this._key = _nodeForge.rsa.generateKeyPair({ bits: 2048 }).privateKey;
  };

  this.publicKey = function () {
    return new RSAPublicKey(_nodeForge.pki.setRsaPublicKey(_this._key.n, _this._key.e));
  };

  this.sign = function (message) {
    var hash = _nodeForge.md.sha256.create();
    hash.update((0, _utils.bytesToString)(message));
    return _this._key.sign(hash);
  };

  this.decrypt = function (ciphertext) {
    // the length of the encrypted aes key is equal to
    // the modulus of the RSA key.
    var modulus = _this._key.n.bitLength() / 8;

    var decodedBytes = _nodeForge.util.decode64(ciphertext);
    var encryptedAESKey = decodedBytes.slice(0, modulus);
    var message = decodedBytes.slice(modulus);

    if (!encryptedAESKey || !message) {
      throw new Error('wrong ciphertext format');
    }
    // Decrypt symmetric key with private key
    var key = _this._key.decrypt(encryptedAESKey, 'RSA-OAEP');
    var symmetricKey = new _aes.SymmetricKey(key);

    // Decrypt message
    return symmetricKey.decrypt(_nodeForge.util.encode64(message));
  };

  this.decryptShort = function (ciphertext) {
    return _this._key.decrypt(_nodeForge.util.decode64(ciphertext), 'RSA-OAEP');
  };

  this.toPkcs8 = function () {
    var privateKey = _nodeForge.pki.privateKeyToAsn1(_this._key);
    return _nodeForge.pki.wrapRsaPrivateKey(privateKey);
  };
};

var RSAPublicKey = exports.RSAPublicKey = function RSAPublicKey(key) {
  _classCallCheck(this, RSAPublicKey);

  _initialiseProps2.call(this);

  this._key = key;
}

/*
Encrypts a message.
It formats the encrypted message as follows:
- <encryptedAESKey><ciphertext>
*/
;

var _initialiseProps2 = function _initialiseProps2() {
  var _this2 = this;

  this.verify = function (message, signature) {
    var hash = _nodeForge.md.sha256.create();
    hash.update((0, _utils.bytesToString)(message));
    return _this2._key.verify(hash.digest().bytes(), signature);
  };

  this.encrypt = function (message) {
    // Generate a symmetric key to encrypt the message
    var symmetricKey = new _aes.SymmetricKey();
    var ciphertext = symmetricKey.encrypt(message);

    // Encrypt symmetric key with public key

    var _symmetricKey$export = symmetricKey.export(),
        key = _symmetricKey$export.key;

    var encryptedAESKey = _this2._key.encrypt(key, 'RSA-OAEP');

    return _nodeForge.util.encode64('' + encryptedAESKey + _nodeForge.util.decode64(ciphertext));
  };

  this.encryptShort = function (message) {
    return _nodeForge.util.encode64(_this2._key.encrypt(message, 'RSA-OAEP'));
  };

  this.toAsn1 = function () {
    return _nodeForge.pki.publicKeyToAsn1(_this2._key);
  };
};